import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { ProposedPlanDTO } from './useProposedPlansQuery';

export interface EditPlanParams {
  clientId: string;
  PlansToUpdate?: ProposedPlanDTO[];
  PlansToDelete?: ProposedPlanDTO[];
}

const editPlan = (params: EditPlanParams): Promise<string> => {
  return authFetch('/Consumer/ManagePlans/SaveChanges', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });
};

export const useEditPlanMutation = () => {
  return useMutation(editPlan);
};
